/* Wait for data-yotpo-element-loaded="true" to be set on the carousel element using intervals and not mutation observer. Then for each '.reviewer-info' element in the carousel console.log */

document.addEventListener('DOMContentLoaded', function () {
    return;
  const carouselInterval = setInterval(() => {
    if (
      document.querySelector('[data-yotpo-element-loaded="true"]') &&
      document.querySelectorAll('.reviews-carousel-reviewer-info-container')
        .length > 0
    ) {
      setTimeout(() => {
        [...document.querySelectorAll('.glide__slide')].forEach((el) => {
          const innerT = el.querySelector('.review-product-name').innerText;
          el.querySelector(
            '.review-product-name'
          ).innerHTML = `<span class="review-subdued">Reviewed on: </span> <span class="review-normal">${innerT}</span>`;
        });
        document.querySelector(
          '[data-yotpo-element-loaded="true"] .glide__arrow--right'
        ).innerHTML = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.67773 13.3597L11.0001 7.99994L5.67773 2.64014" stroke="black" stroke-width="2"/>
        </svg>
        `;
        document.querySelector(
          '[data-yotpo-element-loaded="true"] .glide__arrow--left'
        ).innerHTML = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.3223 13.3597L4.9999 7.99994L10.3223 2.64014" stroke="black" stroke-width="2"/>
        </svg>`;
        const topBarToBeMoved = document.querySelector('.yotpo-top-header');
        const carousel = document.querySelector(
          '.yotpo-reviews-carousel-header'
        );

        carousel.insertAdjacentElement('beforebegin', topBarToBeMoved);
        topBarToBeMoved.classList.remove('hidden');
        topBarToBeMoved.classList.add('flex');
      }, 2000);
      clearInterval(carouselInterval);
    }
  }, 1000);
});
